import { types as sdkTypes } from './sdkLoader';
import { convertMoneyToNumber } from './currency';

const { Money } = sdkTypes;

const toListingId = listing => listing?.id?.uuid || listing?.id || null;

const trackMeta = (eventName, payload) => {
  try {
    if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
      return;
    }
    if (payload && Object.keys(payload).length > 0) {
      window.fbq('track', eventName, payload);
    } else {
      window.fbq('track', eventName);
    }
  } catch (_) {
    // Silently fail analytics
  }
};

export const trackMetaPageView = () => {
  trackMeta('PageView');
};

export const trackMetaViewContentForListing = listing => {
  const listingId = toListingId(listing);
  if (!listingId) {
    return;
  }

  const payload = {
    content_ids: [String(listingId)],
    content_type: 'product',
  };

  const price = listing?.attributes?.price;
  if (price instanceof Money && price.currency) {
    payload.value = convertMoneyToNumber(price);
    payload.currency = String(price.currency).toUpperCase();
  }

  trackMeta('ViewContent', payload);
};

export const trackMetaAddToCart = ({ contentId, value, currency, quantity } = {}) => {
  const payload = {
    content_type: 'product',
  };

  if (contentId) {
    payload.content_ids = [String(contentId)];
  }
  if (value != null && currency) {
    payload.value = Number(value);
    payload.currency = String(currency).toUpperCase();
  }
  if (quantity != null && !Number.isNaN(Number(quantity))) {
    payload.num_items = Number(quantity);
  }

  trackMeta('AddToCart', payload);
};

export const trackMetaInitiateCheckout = ({
  listing,
  allItems,
  orderData,
  currencyFallback,
} = {}) => {
  const lines =
    Array.isArray(allItems) && allItems.length > 0 ? allItems : [{ listing, orderData: orderData || {} }];

  const payload = { content_type: 'product' };
  const contentIds = [];
  let value = 0;
  let valueCurrency = null;
  let hasPrice = false;
  let totalQuantity = 0;

  lines.forEach(line => {
    const lineListing = line?.listing;
    const contentId = toListingId(lineListing);
    if (contentId) {
      contentIds.push(String(contentId));
    }

    const quantity = Number(line?.orderData?.quantity) || 1;
    totalQuantity += quantity;

    const price = lineListing?.attributes?.price;
    if (price instanceof Money && price.currency) {
      const lineCurrency = String(price.currency).toUpperCase();
      if (!valueCurrency || valueCurrency === lineCurrency) {
        value += convertMoneyToNumber(price) * quantity;
        valueCurrency = lineCurrency;
        hasPrice = true;
      } else {
        // Mixed currencies are unsupported in one pixel value payload.
        hasPrice = false;
      }
    }
  });

  if (contentIds.length > 0) {
    payload.content_ids = [...new Set(contentIds)];
  }
  if (totalQuantity > 0) {
    payload.num_items = totalQuantity;
  }

  if (hasPrice) {
    payload.value = Number(value.toFixed(2));
    payload.currency = valueCurrency || String(currencyFallback || '').toUpperCase() || undefined;
  }

  trackMeta('InitiateCheckout', payload);
};

export const trackMetaPurchase = ({ value, currency, transactionId, itemCount, contentIds } = {}) => {
  if (value == null || !currency) {
    return;
  }

  const payload = {
    value: Number(value),
    currency: String(currency).toUpperCase(),
    content_type: 'product',
  };

  if (Array.isArray(contentIds) && contentIds.length > 0) {
    payload.content_ids = [...new Set(contentIds.map(id => String(id)))];
  }
  if (itemCount != null && !Number.isNaN(Number(itemCount))) {
    payload.num_items = Number(itemCount);
  }
  if (transactionId) {
    payload.transaction_id = String(transactionId);
  }

  trackMeta('Purchase', payload);
};
